<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  color: { type: String, default: null },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);
const isLabel = computed(() => !!props.color);
</script>

<template>
  <button
    type="button"
    class="relative inline-flex items-center gap-3 px-4 py-2 text-sm rounded-full border transition-all duration-150 focus:outline-none"
    :class="
      selected
        ? 'border-woot-500 bg-woot-50 text-woot-700'
        : 'border-n-slate-7 bg-n-alpha-1 text-n-slate-12 hover:border-n-slate-9'
    "
    @click="emit('toggle')"
  >
    <span
      v-if="isLabel"
      class="w-4 h-4 rounded-full border shrink-0"
      :style="{
        backgroundColor: color,
        borderColor: color,
      }"
    />
    <span
      v-else
      class="flex items-center justify-center w-4 h-4 rounded-full border shrink-0"
      :class="
        selected
          ? 'border-woot-500 bg-woot-500 text-woot-700'
          : 'border-n-slate-8 bg-transparent'
      "
    >
      <span v-if="selected" class="font-bold">
        {{ $t('FILTER.CHECK') }}
      </span>
    </span>

    <span class="whitespace-nowrap">
      {{ label }}
    </span>
  </button>
</template>
